var SystemSearch = function (options) {
    this.settings = $.extend(true, {}, this.defaults, options);
    this.init();
};

SystemSearch.prototype = {
    constructor: SystemSearch,

    defaults: {
        form: '',
        filters: {
            classification: '',
            text: '',
            type: '',
            sortBy: 'id',
            sortOrder: 'asc',
            filterBy: {},
            searchBy: '',
            perPage: 10,
            page: 1,
        },
        autoSearch: true,
        delay: 600,
        operation: '',
        container: '',
        searchInput: '',
        resultContainer: '',
        perPageSelector: '',
        request: '',
        loadingClass: 'is-searching',
        saveSettings: true,
        searchThreshold: 3,
        onBeforeSearch: function () {},
        onRestore: function () {},
        onSuccess: function () {},
        onDestroy: function () {},
        customEvents: function () {},
    },

    _request: '',

    timeout: null,

    init: function () {
        // store custom _this.settings
        var _this = this;

        // if there are no settings that were stored, then set the defaults
        if (_this.settings.saveSettings) {
            //restore _this.settings from local storage
            _this.restoreSearchSettings();
        }

        // binding events
        _this.bindEvents();

        // trigger initial search
        if (_this.settings.autoSearch) {
            _this.triggerSearch();
        }
    },

    restoreSearchSettings: function () {
        // call the function if it was defined
        var _this = this,
            _filters = WebStorage.get(
                _this.settings.operation + '_' + _this.settings.form
            );

        if (_filters) {
            var filters = JSON.parse(_filters);

            _this.settings.filters.perPage = filters.perPage;
            _this.settings.filters.page = filters.page;
            _this.settings.filters.text = filters.text;

            $(_this.settings.searchInput).val(filters.text);
        }

        _this.settings.onRestore.call(this, filters);
    },

    triggerSearch: QGIV.Utilities.debounce(function () {
        // trigger search
        var _this = this;
        var storageName = _this.settings.operation + '_' + _this.settings.form;
        var $customRangeStart = $('.js-custom-range-start');
        var $customRangeEnd = $('.js-custom-range-end');

        _this.startSearchUI();

        // abort previous call if there was any
        if (_this._request != '') _this._request.abort();

        _this.settings.onBeforeSearch.call(_this);

        // grab date range if present
        if (
            $customRangeStart &&
            $customRangeStart.val() &&
            $customRangeStart.val().length > 0
        ) {
            if (!_this.settings.filters.filterBy.date) {
                _this.settings.filters.filterBy.date = {
                    start: $customRangeStart.val(),
                };
            } else {
                _this.settings.filters.filterBy.date.start = $customRangeStart.val();
            }
        } else if (_this.settings.filters.filterBy.date) {
            // if no field value but still have stored date, remove it
            delete _this.settings.filters.filterBy.date.start;
        }

        if (
            $customRangeEnd &&
            $customRangeEnd.val() &&
            $customRangeEnd.val().length > 0
        ) {
            if (!_this.settings.filters.filterBy.date) {
                _this.settings.filters.filterBy.date = {
                    end: $customRangeEnd.val(),
                };
            } else {
                _this.settings.filters.filterBy.date.end = $customRangeEnd.val();
            }
        } else if (_this.settings.filters.filterBy.date) {
            // if no field value but still have stored date, remove it
            delete _this.settings.filters.filterBy.date.end;
        }

        if (_this.settings.saveSettings)
            WebStorage.set(storageName, JSON.stringify(_this.settings.filters));

        var post_data = _this.settings.filters;

        post_data.csrfToken = $('#csrfToken').val_or_empty();

        // perform ajax request
        _this._request = $.ajax({
            url: _this.settings.request,
            dataType: 'JSON',
            data: post_data,
            type: 'POST',
            success: function (data) {
                if (data.success) {
                    // remove loading graphic
                    _this.endSearchUI();

                    // remove hightlight
                    //if (_this._isHighlighted) _this._highlighContainer.removeHighlight();

                    // render new results to screen
                    $(_this.settings.resultContainer).html(data.html);

                    // custom function called
                    _this.settings.onSuccess.call(_this, data);

                    // apply new highlight to the search key
                    //if (_this._isHighlighted) _this._resultContainer.highlight(_this._searchInput.val());
                }
            },
        });
    }, 200),

    bindEvents: function () {
        // bind all events here
        var _this = this;

        $(_this.settings.searchInput).on('keyup', function (e) {
            var value = $(this).val();

            _this.settings.filters.text = value;

            clearTimeout(_this.timeout);

            if (
                value.length >= _this.settings.searchThreshold ||
                value.length === 0 ||
                e.keyCode == '13'
            ) {
                _this.timeout = setTimeout(function () {
                    _this.settings.filters.page = _this.defaults.filters.page;
                    _this.triggerSearch();
                }, _this.settings.delay);
            }
        });

        $('.reset-filter-search,.reset-search').on('click', function () {
            _this.resetSearch();
        });

        $('.filter-option-button').on('click', function () {
            $(this).toggleClass('active');
        });

        /*$('#attributes', _this.settings.container).on('change', function(e) {
			_this.resetPagination(); 
			_this.triggerSearch();
		});

		$('#sort-order', _this.settings.container).on('change', function(e) {
			_this.resetPagination();
			_this.triggerSearch();
		});*/

        $(_this.settings.container).on(
            'click',
            '.ui-pagination-move',
            function (e) {
                e.preventDefault();

                // prevent triggering any search when disabled pagination prev or next link is clicked
                if (!$(this).hasClass('inactive')) {
                    _this.settings.filters.page = $(this)
                        .closest('li')
                        .attr('data-page');
                    _this.triggerSearch();
                }
            }
        );

        $(_this.settings.container).on(
            'click',
            '.ui-pagination-link',
            function (e) {
                e.preventDefault();
                _this.settings.filters.page = $(this)
                    .closest('li')
                    .attr('data-page');
                _this.triggerSearch();
            }
        );

        $(_this.settings.container).on(
            'change',
            this.settings.perPageSelector,
            function (e) {
                _this.settings.filters.page = _this.defaults.filters.page;
                _this.settings.filters.perPage = $(this).val();
                _this.triggerSearch();
            }
        );

        _this.settings.customEvents.call(this);
    },

    unbindEvents: function () {
        var _this = this;

        $(_this.settings.searchInput).off('keyup');

        $('.reset-filter-search').off('click');

        $('.reset-search').off('click');

        $('.filter-option-button').off('click');

        $(_this.settings.container).off('click', '.ui-pagination-move');

        $(_this.settings.container).off('click', '.ui-pagination-link');

        $(_this.settings.container).off(
            'change',
            this.settings.perPageSelector
        );
    },

    startSearchUI: function () {
        var _this = this;
        $(_this.settings.searchInput).addClass(_this.settings.loadingClass);
        $(_this.settings.resultContainer).css({ opacity: 0.4 });

        // Displays loading indicator if one exists
        if (
            $(_this.settings.resultContainer)
                .closest(_this.settings.container)
                .find('.ui-loading').length > 0
        ) {
            $(_this.settings.resultContainer)
                .closest(_this.settings.container)
                .addClass('show-loading-indicator');
            $(_this.settings.resultContainer)
                .closest(_this.settings.container)
                .find('.ui-loading')
                .removeClass('hide-content');
        }
    },

    endSearchUI: function () {
        var _this = this;
        $(_this.settings.searchInput).removeClass(_this.settings.loadingClass);
        $(_this.settings.resultContainer).css({ opacity: 1 });

        // Hides loading indicator if one exists
        if (
            $(_this.settings.resultContainer)
                .closest(_this.settings.container)
                .find('.ui-loading').length > 0
        ) {
            $(_this.settings.resultContainer)
                .closest(_this.settings.container)
                .removeClass('show-loading-indicator');
            $(_this.settings.resultContainer)
                .closest(_this.settings.container)
                .find('.ui-loading')
                .addClass('hide-content');
        }
    },

    resetPagination: function () {
        var _this = this;
        _this.settings.itemsPerPage = _this.settings.defaultItemsPerPage;
        _this.settings.page = _this.settings.defaultPage;
    },

    resetTypeFilters: function () {
        var _this = this;
        $(_this.settings.container)
            .find('.filter-option-button')
            .removeClass('active');
        $(_this.settings.container)
            .find('.js-custom-range-start,.js-custom-range-end')
            .val('');
        //reset filters
        _this.settings.filters.perPage = _this.defaults.filters.perPage;
        _this.settings.filters.page = _this.defaults.filters.page;
        _this.settings.filters.searchBy = _this.defaults.filters.searchBy;
        _this.settings.filters.filterBy = _this.defaults.filters.filterBy;
    },

    resetSearch: function () {
        var _this = this;
        _this.settings.filters.text = '';
        $(_this.settings.container).find(_this.settings.searchInput).val('');

        //reset all filters
        _this.resetTypeFilters();

        //perform search
        _this.triggerSearch();
    },

    destroy: function () {
        var _this = this;
        _this.unbindEvents();
        _this.settings.onDestroy.call(_this);
    },
};
